import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./callBackFunctions";

export default function standart() {}

export const fillDetail = () => {
  $("#d-algemeen-gisratio").html(
    window.$mm_budget_selectedRow.algemeenGisratio
  );
  $("#d-status").html(window.$mm_budget_selectedRow.status);
  $("#d-maatregel-naam").html(window.$mm_budget_selectedRow.maatregelNaam);
  $("#d-budget-naam").html(window.$mm_budget_selectedRow.budgetNaam);
  $("#d-discipline-naam").html(window.$mm_budget_selectedRow.disciplineNaam);
  $("#d-werkplan-naam").html(window.$mm_budget_selectedRow.werkplanNaam);
};

export function GetColumnProperties(callType) {}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {}

export async function DefinationStatus() {
  var model = {
    definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    query: {
      definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    },
  };
  let result = await omnimap.GetDefinationStatusAction(
    model,
    window.$mm_management_units_token
  );

  if (result.data !== undefined) {
    result.data.forEach((element) => {
      window.$mm_budget_plannigStatus.push(element.status);
    });
  }
}

export function rowsHandleDelete() {
  $("#cover-spin").show(0);

  window.$mm_budget_selectedRow.forEach((element) =>
    omnimap
      .Delete(element, window.$mm_management_units_token)
      .then((result) => {
        CallBackFunctions.RowsDeletedCallBack(
          window.$mm_management_units_token
        );
      })
      .catch((error) => {
        console.log(error);
      })
  );
}
